
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

let secret = '';

export default defineComponent({
  name: 'Login',
  computed: {
    ...mapState(['aid'])
  },
  setup(props, context) {
    const _this = getCurrentInstance() as any
    const $store = useStore()
    const $useRouter = useRouter()
    const phone = ref<string>()
    const code = ref<string>()
    const notice = ref<string>()
    const codeTimes = ref<number>(0)  // 短信验证码倒计时

    onMounted(() => {
      _this.proxy.$common.pageLoaded()
      _this.proxy.$common.track('load', '进入首页')
      _this.proxy.$common.onshare($store.state.shareData)
      secret = sessionStorage.getItem('xcds_secret') || '';
      console.log($useRouter);
    })

    const handleCode = () => {
      const phoneValue = phone.value + '';
      if (!phoneValue) {
        notice.value = '请输入手机号!';
        return;
      }

      if (!/^13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57][0-9]{8}$/.test(phoneValue) || phoneValue.length !== 11) {
        notice.value = '请输入正确的手机号!';
        return;
      }

      const captcha = new window.TencentCaptcha('2084154158', (ret) => {
        if (ret.ticket) {
          // 人机验证
          _this.proxy.$request('/temporary/xcds/captcha', {
            phone: phoneValue,
            randstr: ret.randstr,
            ticket: ret.ticket
          }, 'post').then(res => {
            if (res.sign) {

              // 发送短信
              _this.proxy.$request('/temporary/xcds/sms', {
                aid: _this.ctx.aid,
                phone: phoneValue,
                sign: res.sign,
              }, 'post').then(res => {
                secret = res.secret;
                sessionStorage.setItem('xcds_secret', secret);
                codeTimes.value = 60;
                countDown();
              }).catch(err => {
                notice.value = '网络错误，请重新再试~';
              });

            }
          }).catch(err => {
            notice.value = '网络错误，请重新再试~';
          });
        } else {
          
        }
      })
      captcha.show();
    }

    const handleLogin = () => {
      const phoneValue = phone.value + '';
      const codeValue = code.value + '';

      if (!secret) {
        notice.value = '验证码无效';
        return;
      }

      _this.proxy.$request('/temporary/xcds/login', {
        secret,
        aid: _this.ctx.aid,
        phone: phoneValue,
        code: codeValue,
      }, 'post').then(res => {
        sessionStorage.setItem('xcds_phone', phoneValue);
        sessionStorage.setItem('xcds_token', res.token);
        $useRouter.push('/');
      }).catch(err => {
        notice.value = '验证码错误';
      });
    }

    const handleInput = () => {
      notice.value = ''
    }

    // 倒计时
    function countDown() {
      let times = codeTimes.value || 0;
      if (times > 0) {
        const down = setInterval(() => {
          if (times <= 0) {
            clearInterval(down);
          }
          times--;
          codeTimes.value = times;
        }, 1000)
      }
    }

    return {
      handleCode,
      phone,
      code,
      notice,
      handleInput,
      codeTimes,
      handleLogin,
    }
  }
})
